import { ListBox, Table } from '@flos/react-ui';
import { type RowInformation } from '../../../config/flavourConfig';
import { getYouHaveInformedCoverableDetailsConfig } from '../utils/CoverableDetailsYouHaveInformedUtil';
import { type CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import ItemListRow from '../../../shared_components/ItemListRow/ItemListRow';
import TableRow from '../../../shared_components/TableRow/TableRow';
import { useHippoText } from '../../../hooks/useHippoText';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsYouHaveInformed = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = isMobileDevice;
    const getHippoText = useHippoText();
    const componentProperties = getYouHaveInformedCoverableDetailsConfig(coverable, getHippoText);
    const flavourRequiresTableRow = ['Bilforsikring'];

    const coverableProperties = componentProperties?.rowsInformation.filter(
        (tableInfo) => !tableInfo.hidden
    );

    if (!coverable || !coverableProperties || coverableProperties.length === 0) {
        return <></>;
    }

    return (
        <div className="u-spacing-inset-m--stretch-max">
            <ListBox title={componentProperties?.title ?? ''} isOpen={!listBoxIsOpen}>
                <Table mobileDirection="vertical" className="u-spacing-stack-sm" wrapped={true}>
                    <Table.Body>
                        {coverableProperties.map((rowInfo: RowInformation) => {
                            return flavourRequiresTableRow.includes(
                                coverable?.flavourName ?? ''
                            ) ? (
                                <TableRow key={rowInfo.name} rowInfo={rowInfo} />
                            ) : (
                                <ItemListRow key={rowInfo.name} rowInfo={rowInfo} />
                            );
                        })}
                    </Table.Body>
                </Table>
            </ListBox>
        </div>
    );
};

export default CoverableDetailsYouHaveInformed;
